var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ai-assistant-prompts" },
    _vm._l(_vm.promptsList, function (item, index) {
      return _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: item.prompts && item.prompts.length > 0,
              expression: "item.prompts && item.prompts.length > 0",
            },
          ],
          key: index,
          staticClass: "ai-assistant-prompts",
        },
        [
          _c("div", { staticClass: "ai-assistant-prompts__title" }, [
            _vm._v(_vm._s(item.group_name)),
          ]),
          _c(
            "a-space",
            { staticStyle: { "flex-wrap": "wrap" } },
            _vm._l(item.prompts, function (pItem, pIndex) {
              return _c(
                "div",
                {
                  key: `${index}-${pIndex}`,
                  staticClass: "ai-assistant-prompts-card",
                  on: {
                    click: function ($event) {
                      return _vm.onClick(pItem)
                    },
                  },
                },
                [
                  _c("TextTooltip", {
                    staticClass: "ai-assistant-prompts__title",
                    attrs: { text: pItem.title },
                  }),
                  _c("div", { staticClass: "ai-assistant-prompts__desc" }, [
                    _vm._v(_vm._s(pItem.content)),
                  ]),
                ],
                1
              )
            }),
            0
          ),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }